<template>
    <v-container>
        <v-row>
            <v-col
                no-gutter
                cols="12"
                md="9"
                class="text--secondary"
            >
                <h1>{{ $t('menu.' + $route.name) }}</h1>
                <p  v-for="(a,key) in $t('ips.page.introduction')" :key="'a' + key" v-html="a"></p>
                <h2 v-text="$t('ips.page.process.title')" class="mt-8"></h2>
                <p  v-for="(a,key) in $t('ips.page.process.text')" :key="'b' + key" v-html="a"></p>
            </v-col>
            <v-col
                cols="12"
                md="3"
            >
                <side-bar></side-bar>
            </v-col>
        </v-row>

    </v-container>

</template>

<script>
export default {
}
</script>
